import React, { useState, useEffect } from "react";

const ExecutionResultsUI = () => {
  const [executions, setExecutions] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  useEffect(() => {
    fetchExecutions();
  }, []);

  const fetchExecutions = async () => {
    try {
      const response = await fetch("/composite-backend/internal/ui/rules/get-all-executions");
      const data = await response.json();
      if (response.ok && data.executions) {
        console.log("Fetched Executions:", data.executions);
        setExecutions(data.executions);
      } else {
        console.error("Error fetching executions:", data.error);
      }
    } catch (error) {
      console.error("Error fetching executions:", error);
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedExecutions = [...executions].sort((a, b) => {
    if (!sortConfig.key) return 0;

    let aValue = a[sortConfig.key] || "";
    let bValue = b[sortConfig.key] || "";

    // Sort timestamps as actual dates
    if (sortConfig.key === "execution_start_time") {
      aValue = Date.parse(aValue) || 0;
      bValue = Date.parse(bValue) || 0;
    }

    // Sort execution duration as numbers
    if (sortConfig.key === "execution_duration") {
      aValue = parseInt(aValue) || 0;
      bValue = parseInt(bValue) || 0;
    }

    // String-based sorting
    if (typeof aValue === "string" && typeof bValue === "string") {
      return sortConfig.direction === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }

    return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
  });

  return (
    <div style={{ padding: "24px", fontFamily: "Arial, sans-serif" }}>
      {/* Header Section */}
      <header style={{ backgroundColor: "#007BFF", padding: "16px", color: "#FFF", textAlign: "center" }}>
        <h2>Sandbox Execution Results</h2>
      </header>

      {/* Execution History Table */}
      <div style={{ marginTop: "20px" }}>
        <h3>Execution History</h3>
        <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #D1D5DB", fontSize: "14px" }}>
          {/* Table Header */}
          <thead>
            <tr style={{ backgroundColor: "#f3f4f6", textAlign: "left" }}>
              <th onClick={() => handleSort("execution_id")} style={{ cursor: "pointer", padding: "12px", border: "1px solid #D1D5DB" }}>
                Execution ID {sortConfig.key === "execution_id" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
              </th>
              <th onClick={() => handleSort("execution_start_time")} style={{ cursor: "pointer", padding: "12px", border: "1px solid #D1D5DB" }}>
                Start Time {sortConfig.key === "execution_start_time" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
              </th>
              <th onClick={() => handleSort("status")} style={{ cursor: "pointer", padding: "12px", border: "1px solid #D1D5DB" }}>
                Status {sortConfig.key === "status" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
              </th>
              <th onClick={() => handleSort("result")} style={{ cursor: "pointer", padding: "12px", border: "1px solid #D1D5DB" }}>
                Result {sortConfig.key === "result" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
              </th>
              <th style={{ padding: "12px", border: "1px solid #D1D5DB" }}>Rule Name</th>
              <th style={{ padding: "12px", border: "1px solid #D1D5DB" }}>Description</th>
              <th style={{ padding: "12px", border: "1px solid #D1D5DB" }}>Disposition</th>
              <th onClick={() => handleSort("execution_duration")} style={{ cursor: "pointer", padding: "12px", border: "1px solid #D1D5DB" }}>
                Duration (ms) {sortConfig.key === "execution_duration" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {sortedExecutions.length > 0 ? (
              sortedExecutions.map((execution, index) => (
                <React.Fragment key={index}>
                  <tr style={{ borderBottom: "1px solid #ddd", backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff", fontWeight: "bold" }}>
                    <td style={{ padding: "12px" }}>{execution.execution_id}</td>
                    <td style={{ padding: "12px" }}>{new Date(execution.execution_start_time).toLocaleString()}</td>
                    <td style={{ padding: "12px" }}>{execution.status}</td>
                    <td style={{ padding: "12px" }}>{execution.result}</td>
                    <td style={{ padding: "12px" }}>{execution.rule_name}</td>
                    <td style={{ padding: "12px" }}>{execution.description}</td>
                    <td style={{ padding: "12px" }}>{execution.disposition}</td>
                    <td style={{ padding: "12px" }}>{execution.execution_duration}</td>
                  </tr>

                  {/* Child Rows */}
                  {execution.children && execution.children.length > 0 && (
                    execution.children.map((child, childIndex) => (
                      <tr key={`child-${index}-${childIndex}`} style={{ backgroundColor: "#eef7ff", borderBottom: "1px solid #ddd" }}>
                        <td style={{ padding: "12px" }}></td>
                        <td style={{ padding: "12px" }}>{child.task_id}</td>
                        <td style={{ padding: "12px" }}>{child.rule_id}</td>
                        <td style={{ padding: "12px" }}>{child.rule_name}</td>
                        <td style={{ padding: "12px" }}>{child.description}</td>
                        <td style={{ padding: "12px" }}>{child.disposition}</td>
                        <td style={{ padding: "12px" }}>{child.execution_duration}</td>
                      </tr>
                    ))
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", padding: "12px" }}>No executions found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={{ backgroundColor: "#007BFF", color: "#FFF", textAlign: "center", padding: "16px", marginTop: "20px" }}>
        <p>Idenza © 2025</p>
      </div>
    </div>
  );
};

export default ExecutionResultsUI;

